import { MutationTree } from 'vuex';

import {
  QuizzesStateI,
} from './state';

export const mutations: MutationTree<QuizzesStateI> = {
};
